<div class="contact-page-wrapper">
  <h2 class="title">{{ "CONTACT_PAGE.NEED_HELP_Q" | translate }} ?</h2>
  <p class="desc">{{ "CONTACT_PAGE.CONTACT_CLIENT_SUPPORT" | translate }}</p>
  <img
    class="contact-image"
    src="../../../assets/img/contact.svg"
    alt="contact image"
  />
  <button (click)="handleCallModal(true)" class="apply-btn">
    {{ "CONTACT_PAGE.CALL_CLIENT_SUPPORT" | translate }} ?
  </button>
  <button (click)="goToMessagerie('messagerie')" class="discute-btn">
    {{ "CONTACT_PAGE.DISCUTE_CLIENT_SUPPORT" | translate }} ?
    <!-- {{ adminMessageCount }} -->
  </button>
</div>
<ion-modal
  [isOpen]="callModal"
  [initialBreakpoint]="1"
  [breakpoints]="[0, 1]"
  class="phone-call-modal"
  (ionModalDidDismiss)="handleCallModal(false)"
>
  <ng-template>
    <div class="modal-content">
      <h2>{{ "CONTACT_PAGE.PHONE_MODAL.CLIENT_S" | translate }}</h2>
      <a class="call-button" [href]="'tel:' + phoneNumber">{{
        "CONTACT_PAGE.PHONE_MODAL.CALL_WITH_PHONE" | translate
      }}</a>
    </div>
  </ng-template>
</ion-modal>
